// import { css } from '@emotion/core'
import styled from "@emotion/styled";

const Flex = styled.div`
  display: flex;
`;

export default Flex;

export const TwoCol = styled(Flex)`
  & > div {
    width: 50%;
  }

  @media only screen and (max-width: 520px) {
    & > div {
      width: 100%;
    }
  }
`;
